module.exports = __webpack_public_path__ + "img/VS.681696dc.png";